module.exports = __webpack_public_path__ + "media/images/products/products/h3-bebf3c088b354c796ce2b3228ddde84a.jpg";